<template>
  <BaseDialog
    :title="isShowMode ? 'Просмотр' : isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UITextField
      v-model="event.name"
      label="Название"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.event.name.$touch()"
    />

    <UITextField
      v-model="event.address"
      label="Адрес"
      :disabled="isShowMode"
      :error-messages="errorMessages.address"
      @input="$v.event.address.$touch()"
    />

    <UIAutocomplete
      v-model="event.action"
      label="Действия"
      multiple
      return-object
      :items="actionDirectory"
      :disabled="isShowMode"
      :error-messages="errorMessages.action"
      @input="$v.event.action.$touch()"
    />

    <UITextField
      v-model="event.contactData"
      label="Контактные данные"
      :disabled="isShowMode"
      :error-messages="errorMessages.contactData"
      @input="$v.event.contactData.$touch()"
    />

    <v-row class="my-0">
      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pr-1': !isXs}">
        <UIDatePickerMenu
          v-model="event.dateFrom"
          label="Дата начала"
          :disabled="isShowMode"
          :error-messages="errorMessages.dateFrom"
          @input="$v.event.dateFrom.$touch()"
        />
      </v-col>

      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pl-1': !isXs}">
        <UITextField
          v-model="event.timeFrom"
          v-mask="'##:##'"
          label="Время начала"
          :disabled="isShowMode"
          :error-messages="errorMessages.timeFrom"
          @input="$v.event.timeFrom.$touch()"
        />
      </v-col>
    </v-row>

    <v-row class="my-0">
      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pr-1': !isXs}">
        <UIDatePickerMenu
          v-model="event.dateTo"
          label="Дата окончания"
          :disabled="isShowMode"
          :error-messages="errorMessages.dateTo"
          @input="$v.event.dateTo.$touch()"
        />
      </v-col>

      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pl-1': !isXs}">
        <UITextField
          v-model="event.timeTo"
          v-mask="'##:##'"
          label="Время окончания"
          :disabled="isShowMode"
          :error-messages="errorMessages.timeTo"
          @input="$v.event.timeTo.$touch()"
        />
      </v-col>
    </v-row>

    <v-row class="my-0">
      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pl-1': !isXs}">
        <UICheckbox
          :value="event.isHidden"
          label="Скрыть мероприятие"
          hide-details
          @change="(val) => event.isHidden = val"
        />
      </v-col>

      <v-col :cols="isXs ? 12 : 6" class="py-0" :class="{'pl-1': !isXs}">
        <UICheckbox
          :value="event.isClosed"
          label="Закрыть регистрацию"
          hide-details
          @change="(val) => event.isClosed = val"
        />
      </v-col>
    </v-row>
  </BaseDialog>
</template>

<script>
import {
  setValidateMessages,
  dateFormat,
  checkTimeFormat,
} from '@/scripts/validation'
import { Event } from '@/models'
import {
  maxLength,
  required,
} from 'vuelidate/lib/validators'
import {
  mapActions,
  mapGetters,
} from 'vuex'
import UIAutocomplete from '@/ui/input/UIAutocomplete'
import UIDatePickerMenu from '@/ui/input/UIDatePickerMenu'
import UITextField from '@/ui/input/UITextField'
import BaseDialog from '@/ui/dialog/BaseDialog'
import UICheckbox from '@/ui/input/UICheckbox'

export default {
  components: {
    UIDatePickerMenu,
    UIAutocomplete,
    UITextField,
    BaseDialog,
    UICheckbox,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  async mounted() {
    !this.isUser && await this.getDirectories()
  },

  data: () => ({ event: new Event() }),

  validations() {
    return {
      event: {
        name: { required, maxLength: maxLength(200) },
        dateFrom: { required, dateFormat },
        dateTo: { required, dateFormat },
        timeFrom: { required, checkTimeFormat },
        timeTo: { required, checkTimeFormat },
        address: { required },
        action: { required },
        contactData: { maxLength: maxLength(200) },
      },
    }
  },

  computed: {
    ...mapGetters('directories', ['actionDirectory']),
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('user', ['isUser']),

    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.event.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.event[key])
      })

      return allErrors
    },
  },

  methods: {
    ...mapActions('directories', ['getActionDirectory']),

    async getDirectories() {
      try {
        await this.getActionDirectory()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения справочников')
      }
    },

    save() {
      this.$emit('saveEvent', this.event.getForAPI())
    },

    resetModal() {
      this.event = new Event()
      this.$v.$reset()
    },

    closeModal() {
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.event = new Event(val)
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
